import Vue from 'vue'
import VueAMap from 'vue-amap'
import wx from 'weixin-jsapi'
import App from './App.vue'
import router from './router'
import store from './store'
import './directive'
import storage from '@/utils/storage'
import VConsole from 'vconsole'

import {
    amapKey,
    wxAppId,
    wxRedirectUri
} from '@/utils/url-config'

import View from '@/components/view'
import Image from '@/components/image'

import {
    Tabbar,
    TabbarItem,
    NavBar,
    Swipe,
    SwipeItem,
    List,
    Loading,
    PullRefresh,
    Grid,
    GridItem,
    Tab,Tabs
} from 'vant'
import 'vant/lib/index.css';
// 本地开发不开启Vconsole
// if (process.env.NODE_ENV !== 'development') {
//     const vConsole = new VConsole()
//     console.log(vConsole.version)
// }

Vue.component('views', View)
Vue.component('images', Image)

Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(List)
Vue.use(Loading)
Vue.use(PullRefresh)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tab)
Vue.use(Tabs)

Vue.use(VueAMap)

Vue.prototype.wx = wx

VueAMap.initAMapApiLoader({
    key: amapKey,
    plugin: [
        'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView',
        'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation',
        'AMap.AdvancedInfoWindow', 'AMap.GeometryUtil'
    ],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    // 是否需要tabbar
    if (to.meta.requireTabBar) {
        store.commit('SHOW_TAB_BAR', true)
    } else {
        store.commit('SHOW_TAB_BAR', false)
    }
    // 判断该路由是否需要登录权限
    if (to.meta.requireAuth) {
        if (storage.getToken()) {
            next()
        } else {
            console.log(111);
            storage.set('loginAfterUrl', to.fullPath)
            next({ path: '/login', replace: true })
            // 在本地开发可以在浏览器里直接打开
            // if (process.env.NODE_ENV === 'development') {
            //     next()
            //     // next({ path: '/login', replace: true })
            // } else {
            //     storage.set('loginAfterUrl', to.fullPath)
            //     // 微信授权 - 获取code
            //     // window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${wxRedirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`)
            //     // 跳转到登录页面
            //     next({ path: '/login', replace: true })
            // }
        }
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    window.scrollTo(0, 0)
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
